import { Flex, Table, TableProps } from "antd";
import "./SalesLeaderboard.scss";
import { SalesLeaderboardColumns } from "sales/constants";
import { ISalesLeaderboard } from "sales/models";
import variables from "../../../_variables.scss";

type Props = {
  data?: ISalesLeaderboard[];
  dataLoading?: boolean;
  width?: number | string;
};

export const SalesLeaderboard = ({
  data,
  dataLoading,
  width = variables.fullWidth,
}: Props) => {
  const tableColumns = SalesLeaderboardColumns.map((item) => ({ ...item }));
  const tableProps: TableProps<ISalesLeaderboard> = {
    loading: dataLoading,
  };

  return (
    <Flex
      vertical
      gap={variables.smallGap}
      style={{ width }}
      data-testid='salesLeaderboard'
    >
      <h2>Sales Leaderboard</h2>
      <Table
        {...tableProps}
        columns={tableColumns}
        dataSource={data}
        className='sales-leaderboard-table'
        rowKey='salesPerson'
        pagination={false}
        size='small'
        bordered={false}
        scroll={{ y: variables.defaultComponentHeight }}
      />
    </Flex>
  );
};
